"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TimelineFiltersStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineFiltersStore"));

var TimelineTextFilterDependency = {
  stores: [_TimelineFiltersStore.default],
  deref: function deref(_ref) {
    var objectType = _ref.objectType;

    var text = _TimelineFiltersStore.default.get(objectType) && _TimelineFiltersStore.default.get(objectType).get('searchText');

    return text || '';
  }
};
var _default = TimelineTextFilterDependency;
exports.default = _default;
module.exports = exports.default;